<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <div>
                    <form autocomplete="off" >
                        <input [ngModelOptions]="{standalone: true}" placeholder="search user" (keyup)="searchCustomer(0,10)" [(ngModel)]="searchUser"/>
                    </form>
                </div>
                <h4 class="personal-details-title">Modify Users List</h4>
                
                <table class="table table-striped">
                    <thead>
                        <tr>
                        <th scope="col">User Name</th>
                        <th scope="col">User Mobile</th>
                        <th scope="col">User Email</th>
                        <th scope="col">User Type</th>
                        <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let x of users | paginate : {
                            itemsPerPage: tableSize,
                            currentPage: pageNumber1,
                            totalItems: totalRecords
                          }  ;let i = index">
                        <th scope="col">{{x.userName}}</th>
                        <th scope="col">{{x.userMobileNo}}</th>
                        <th scope="col">{{x.userEmail }}</th>
                        <th scope="col">{{x.userType }}</th>
                        <th scope="col">
                            <svg (click)="getUserById(x.userId)" data-toggle="modal" data-target="#updateModal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                            </svg>
                        </th>
                        </tr>
                    </tbody>
                </table>
                <div class="pagination-block" *ngIf="users.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                </div>
            </div>
        </div>
    </div>
</div>
  
  
<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">UPDATE USER
                    <span data-dismiss="modal">
                        <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                        </svg>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="editForm">
                    <div class="form-group">
                        <label>User Name</label>
                        <input formControlName="userName" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>User mobile</label>
                        <input readonly formControlName="userMobileNo" type="number" class="form-control no-edit">
                    </div>
                    <div class="form-group">
                        <label>User Email</label>
                        <input formControlName="userEmail" type="email" class="form-control">
                    </div>
                    <!-- <div class="form-group">
                        <label>User Password</label>
                        <input formControlName="password" value="{{Users.password}}" type="password" class="form-control">
                    </div> -->
                    <div class="form-group">
                        <label>User Type</label>
                        <!-- <input formControlName="userType" type="text" class="form-control"> -->
                        <select name="" id="" formControlName="userType" class="form-control">
                            <option value="{{type}}" *ngFor="let type of userTypes">{{type}}</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Reports To</label>
                        <select name="" id="" formControlName="reportsTo" class="form-control">
                            <option value="" disabled selected hidden>---select type---</option>
                            <option *ngFor="let user of usersWithoutCustomers" [value]="user.userId">{{user.userName}}</option>
                        </select>
                    </div>

                    <div *ngFor="let list of userParams" class="form-group">
                        <label>{{list.name}}</label>
                        <input *ngIf="list.boxType == 'Input'" [ngModelOptions]="{standalone: true}" type="text" [(ngModel)]="list.value" class="form-control">
                        <select name="" id="" *ngIf="list.boxType == 'Dropdown'" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value" class="form-control">
                            <option value="" disabled selected hidden>---select ---</option>
                            <option *ngFor="let dropdownList of list.possibleValue" [value]="dropdownList">{{dropdownList}}</option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="updateUser()" class="btn btn-primary">save changes</button>
                </div>
            </div>
        </div>
    </div>
</div>